import { render, staticRenderFns } from "./NoteManagement.vue?vue&type=template&id=72db3905&"
import script from "./NoteManagement.vue?vue&type=script&lang=js&"
export * from "./NoteManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports